import { render } from "./ControlDescriptor.vue?vue&type=template&id=07de0277&ts=true&lang=pug"
import script from "./ControlDescriptor.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlDescriptor.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__